import { apiInstance } from "../base"
import type { WordPressOptions } from "./types"

const BASE_URL = "/api/options"

export const getOptions = (): Promise<WordPressOptions> => {
    return apiInstance.get(`${BASE_URL}`)
}
